import * as React from 'react'
import Header from './Header'
import Body from './Body'
import Footer from './footer'
import './style.css'

interface ViewLetterProps {
  data?: any
  type?: 'sip' | 'kontrak' | 'so'
  className?: string
}

export const ViewLetter: React.FC<ViewLetterProps> = (props) => {
  return (
    <div className='letter'>
      <Header data={props.data} type={props.type} />
      <br />
      <Body data={props.data} type={props.type} />
      <br />
      <Footer data={props.data} type={props.type} />
    </div>
  )
}

export default React.memo(ViewLetter)
